import React from 'react';
import './styles.css';
import StatisticsList from '../../../../components/StatisticsList';

const FirmStrategyFeatures = ({ data }) => {
  return (
    <div className="firm-strategy-features">
      <div className="firm-strategy__features-header">
        <span className="firm-strategy-features__icon" />
        <h3 className="firm-strategy-features__title">Strategy at a Glance</h3>
      </div>

      <StatisticsList
        objectList={data}
        captionStyles={{
          flex: '1 1 30%',
        }}
        valueStyles={{
          flex: '1 1 70%',
          padding: '0',
          textAlign: 'left',
        }}
      />
    </div>
  );
};

export default FirmStrategyFeatures;
